// https://www.npmjs.com/package/react-router-navigation-prompt
import React from 'react';

import { PropTypes } from 'prop-types';

const initState = {
  action: null,
  isActive: false,
  nextLocation: null
};

class NavigationPrompt extends React.Component {
  constructor(props) {
    super(props);
    this._prevUserAction = '';
    this._isMounted = true;

    this.block = this.block.bind(this);
    this.onBeforeUnload = this.onBeforeUnload.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.when = this.when.bind(this);

    this.state = {
      ...initState,
      unblock: () => {
        // do nothing
      }
    };
  }

  componentDidMount() {
    if (!this.props.disableNative) {
      window.addEventListener('beforeunload', this.onBeforeUnload);
    }

    this.setState({ unblock: this.props.history.block(this.block) });
  }

  componentDidUpdate() {
    if (
      this._prevUserAction === 'CANCEL' &&
      typeof this.props.afterCancel === 'function'
    ) {
      this.props.afterCancel();
    } else if (
      this._prevUserAction === 'CONFIRM' &&
      typeof this.props.afterConfirm === 'function'
    ) {
      this.props.afterConfirm();
    }
    this._prevUserAction = '';
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (
      this._prevUserAction === 'CONFIRM' &&
      typeof this.props.afterConfirm === 'function'
    ) {
      this._prevUserAction = '';
      this.props.afterConfirm();
    }
    this.state.unblock();
    if (!this.props.disableNative) {
      window.removeEventListener('beforeunload', this.onBeforeUnload);
    }
  }

  block(nextLocation, action) {
    const result = this.when(nextLocation);

    if (result) {
      this.setState({
        action,
        nextLocation,
        isActive: true
      });
    }
    return !result;
  }

  navigateToNextLocation() {
    let { action, nextLocation } = this.state;

    action = {
      POP: this.props.allowGoBack ? 'goBack' : 'push',
      PUSH: 'push',
      REPLACE: 'replace'
    }[action || 'PUSH'];

    if (!nextLocation) {
      nextLocation = { pathname: '/' };
    }
    const { history } = this.props;

    this.state.unblock();
    this._prevUserAction = 'CONFIRM';
    if (action === 'goBack') {
      const unlisten = history.listen(() => {
        unlisten();
        if (this._isMounted) {
          this.setState({
            ...initState,
            unblock: history.block(this.block)
          });
        }
      });

      history.goBack();
    } else {
      history[action](nextLocation);
      if (this._isMounted) {
        this.setState({
          ...initState,
          unblock: this.props.history.block(this.block)
        });
      }
    }
  }

  onCancel() {
    (
      this.props.beforeCancel ||
      ((cb) => {
        cb();
      })
    )(() => {
      this._prevUserAction = 'CANCEL';
      this.setState({ ...initState });
    });
  }

  onConfirm() {
    (
      this.props.beforeConfirm ||
      ((cb) => {
        cb();
      })
    )(() => {
      this.navigateToNextLocation(this.props.afterConfirm);
    });
  }

  onBeforeUnload(e) {
    if (!this.when()) {
      return;
    }
    const msg =
      'Do you want to leave this site?\n\nChanges you made may not be saved.';

    e.returnValue = msg;
    return msg;
  }

  when(nextLocation) {
    if (typeof this.props.when === 'function') {
      return this.props.when(this.props.history.location, nextLocation);
    } else {
      return this.props.when;
    }
  }

  render() {
    if (!this.state.isActive && !this.props.renderIfNotActive) {
      return null;
    }
    return (
      <div>
        {this.props.children({
          isActive: this.state.isActive,
          onConfirm: this.onConfirm,
          onCancel: this.onCancel
        })}
      </div>
    );
  }
}

NavigationPrompt.propTypes = {
  when: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
  renderIfNotActive: PropTypes.bool,
  children: PropTypes.node,
  afterCancel: PropTypes.func,
  afterConfirm: PropTypes.func,
  beforeCancel: PropTypes.func,
  beforeConfirm: PropTypes.func,
  allowGoBack: PropTypes.bool,
  disableNative: PropTypes.bool
};

export default NavigationPrompt;
